import { PropsWithChildren } from 'react';

import { clsx } from 'clsx';

import { OptionFilter } from './OptionFilter';

import type { OptionFilters as OptionFiltersType } from '../../types';
import type { EnOrRuLocale } from '@monoimin/sb-types';

type OptionFiltersProps = PropsWithChildren<{
  className?: string;
  options?: OptionFiltersType;
  locale: EnOrRuLocale;
}>;

export const OptionFilters = ({
  className,
  options,
  children,
  locale,
}: OptionFiltersProps) => {
  if (Array.isArray(options) && options.length) {
    return (
      <div className={clsx('flex flex-col gap-3', className)}>
        {children}
        <div className='grid xl:grid-cols-2 gap-5'>
          {options.map((item, index) => {
            return <OptionFilter {...item} locale={locale} key={index} />;
          })}
        </div>
      </div>
    );
  }

  return children;
};
